import {
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage';
import { storage } from './config';

export async function uploadFile(path, file, onProgress) {
  const storageRef = ref(storage, path);

  if (onProgress) {
    const uploadTask = uploadBytesResumable(storageRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress(progress);
        },
        (error) => reject(error),
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        }
      );
    });
  }

  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}

export async function deleteFile(path) {
  const storageRef = ref(storage, path);
  await deleteObject(storageRef);
}

export function getStoragePath(userId, type, filename) {
  const timestamp = Date.now();
  return `${type}/${userId}/${timestamp}_${filename}`;
}

/**
 * Upload a user avatar image
 * @param {string} userId - The user's ID
 * @param {File} file - The image file to upload
 * @returns {Promise<string>} - The download URL of the uploaded image
 */
export async function uploadAvatar(userId, file) {
  // Create a safe filename
  const safeName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
  const timestamp = Date.now();
  const path = `avatars/${userId}/${timestamp}-${safeName}`;

  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}
